/* global $, window */

function init() {

	$('.main-menu__list-toggle-trigger').on('click', (event) => {
		toggle($(event.currentTarget).data('target'));
	});

}

function show(id) {

	const $target = $(`#main-menu__list--${id}`);
	const $trigger = $(`#main-menu__list-toggle-trigger--${id}`);

	$trigger.removeClass('is--hidden');
	$target.removeClass('is--hidden');
	window.greenledStickySidepanel && window.greenledStickySidepanel.updateSticky();

}

function close(id) {

	const $target = $(`#main-menu__list--${id}`);
	const $trigger = $(`#main-menu__list-toggle-trigger--${id}`);

	$trigger.addClass('is--hidden');
	$target.addClass('is--hidden');
	window.greenledStickySidepanel && window.greenledStickySidepanel.updateSticky();

}

function toggle(id) {

	const $target = $(`#main-menu__list--${id}`);

	if ($target.hasClass('is--hidden')) {
		show(id);
	} else {
		close(id);
	}

}

export default {
	init
};
